






































import { defineComponent, computed, ref, watch } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'Pagination',
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    visiblePagesCount: {
      type: Number,
      default: 5
    },
    prevLabel: {
      type: String,
      default: 'Previous'
    },
    nextLabel: {
      type: String,
      default: 'Next'
    }
  },
  setup(props, { emit }) {
    const currentPageValue = ref(props.currentPage);

    // Watch for external changes to currentPage prop
    watch(() => props.currentPage, (newValue) => {
      currentPageValue.value = newValue;
    });

    const totalPages = computed(() => {
      return Math.ceil(props.totalItems / props.pageSize);
    });

    const visiblePages = computed(() => {
      if (totalPages.value <= props.visiblePagesCount) {
        return Array.from({ length: totalPages.value }, (_, i) => i + 1);
      }

      const halfVisible = Math.floor(props.visiblePagesCount / 2);
      let start = currentPageValue.value - halfVisible;
      let end = currentPageValue.value + halfVisible;

      if (start < 1) {
        end = Math.min(totalPages.value, end + (1 - start));
        start = 1;
      }

      if (end > totalPages.value) {
        start = Math.max(1, start - (end - totalPages.value));
        end = totalPages.value;
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    });

    const goToPage = (page: number) => {
      if (page === currentPageValue.value) return;
      currentPageValue.value = page;
      emit('page-change', page);
    };

    const prevPage = () => {
      if (currentPageValue.value > 1) {
        goToPage(currentPageValue.value - 1);
      }
    };

    const nextPage = () => {
      if (currentPageValue.value < totalPages.value) {
        goToPage(currentPageValue.value + 1);
      }
    };

    return {
      currentPageValue,
      totalPages,
      visiblePages,
      goToPage,
      prevPage,
      nextPage
    };
  }
});
